import { gql } from '@apollo/client';

export default gql`
  mutation updateProcRead($procId: String) {
    updateProcRead(procId: $procId) {
      ok
      message
      data
      error
    }
  }
`;
